import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { environment } from '../../../environments/environment';
import { LoggedInUserDeails } from '../services/login.model';

@Injectable({
  providedIn: 'root'
})
export class SsoUserAuthenticationService {

  constructor(private httpclient: HttpClient){}
  post(token: string): Observable <LoggedInUserDeails>{
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Bearer ' + token);
    headers = headers.set('Content-Type', 'application/json');
    const result =  this.httpclient.post(environment.servicePath + '/lfuser/get_account', token, { headers});
    return result as Observable<LoggedInUserDeails>;

  }


}
